<template>
  <div class="shadow-sm py-2">
    <!-- visible on lg and up -->
    <b-container>
      <b-row no-gutters>
        <b-col>
          <b-nav v-if="allRide.ride" fill align="center">
            <b-nav-item
              exact
              active-class="active"
              class="link"
              v-for="(link, index) in resolvedLinks"
              @click="tubCliked(link.modal)"
              :key="index"
              :to="getUrl( link.url )"
              >
              <div class="single_ride_internal_nav_bar">
                {{ link.text }}
                <b-icon :icon="link.icon" variant="warning"></b-icon>
              </div>
            </b-nav-item>
          </b-nav>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>

import { mapActions, mapGetters } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';

export default {
  mixins: [translationMixin],
  props: {
    links: {
      type: Array,
      default: null,
    },
    mobileLinks: {
      type: Array,
      default: null,
    },
  },
  computed: {
    ...mapGetters([
      'allRide',
      "modals",
    ]),
    resolvedLinks() {
      if (this.links) return this.links;
      return [
        {
          text: "",
          icon: "share",
          modal: "shareRide",
        },
        {
          text: this.t('accommodations'),
          icon: "",
          url: "/ride_checklist/",
        },
        {
          text: this.t('innerNavTripAttractions'),
          icon: "",
          url: "/single_ride_with_map/",
        },
      ];
    },
    resolvedMobileLinks() {
      if (this.mobileLinks) return this.mobileLinks;
      return [
        {
          text: this.t('innerNavShareTrip'),
          icon: "icons8-connect-50.png",
          modal: "shareRide",
        },
        {
          text: this.t('innerNavTripAttractions'),
          icon: "",
          url: "/single_ride_with_map/",
        },
        {
          text: this.t('accommodations'),
          icon: "",
          url: "/ride_checklist/",
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      "showModal",
    ]),
    getUrl( url ){
      if( url )
        return url + this.allRide.ride.id.toString();
    },
    tubCliked(modal) {
      if ( modal == '' ){
        return
      }
      this.showModal( modal )
    },
  }
};
</script>
<style>
.active {
  font-style: normal;
  font-weight: normal;
  color: #34d0b6;
}
</style>